import { IReduxState } from 'types/redux';

export const pagesSelector = (state: IReduxState) => state.pages;
